import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=7d410dd4&"
import script from "./CouponCard.vue?vue&type=script&lang=ts&"
export * from "./CouponCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports